import { Logo } from './Logo';
import { Spinner } from '@dd/ui';

export function Splash({ label }: { label?: string }) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-white">
      <Logo size={72} withText />
      <Spinner size={22} className="text-brand" />
      {label && <p className="text-sm text-ink-3">{label}</p>}
    </div>
  );
}
